import {$host} from "./index";

export const fetchArticles = async (title, tags, page) => {
    const {data} = await $host.get('articles/', { params: {title, tags, page}})
    return data
}

export const createArticle = async (title, tags, link) => {
    const {data} = await $host.post('articles/', { title, tags, link })
    return data
}

export const deleteArticle = async (id) => {
    const {data} = await $host.delete('articles/' + `${id}`)
    return data
}
export const updateArticle = async (id, title, tags, link) => {
    const {data} = await $host.patch('articles/' + `${id}`, { title, tags, link })
    return data
}